var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.500122,
    width: 25,
    height: 25,
    rx: 4,
    fill: "#ECF1F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1183 8.0943L17.9058 8.8818C18.3667 9.3368 18.3667 10.0776 17.9058 10.5326L10.1883 18.2501H7.75V15.8118L13.8167 9.7393L15.4675 8.0943C15.9225 7.6393 16.6633 7.6393 17.1183 8.0943ZM8.91667 17.0835L9.73917 17.1185L15.4675 11.3843L14.645 10.5618L8.91667 16.2901V17.0835Z",
    fill: "#154365"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTable);
export default __webpack_public_path__ + "static/media/edit_table.96b69184ee73c5b1c2b2a8e720cf2424.svg";
export { ForwardRef as ReactComponent };